module.exports = __webpack_public_path__ + "img/search_banner.8ead221a.png";